<template>
  <div>
    <div class="content-assesssment-info pb-3">
      <QuestionCard
        :key="index"
        v-for="(item, index) in questions"
        @pickQuestion="pickQuestion"
        @removeQuestion="removeQuestion"
        :question_index="index"
        :question_id="item.id"
        :question="item.question"
        :question_difficulty="item.difficulty"
        :question_type="item.type"
        :question_duration="item.duration + 's'"
        :question_data="item"
        :question_options="[
          {
            id: 'a',
            value: item.option_a,
            correct: item.answer.toLowerCase() == 'a',
          },
          {
            id: 'b',
            value: item.option_b,
            correct: item.answer.toLowerCase() == 'b',
          },
          {
            id: 'c',
            value: item.option_c,
            correct: item.answer.toLowerCase() == 'c',
          },
          {
            id: 'd',
            value: item.option_d,
            correct: item.answer.toLowerCase() == 'd',
          },
        ]"
        :selected="isSelected(item.id)"
        @toggleFeedback="toggleFeedbackModal"
      ></QuestionCard>
    </div>

    <!-- MODAL COMPONENTS -->
    <AssessmentPreviewModal
      :question="question"
      :question_options="[
        {
          id: 'a',
          value: question.option_a,
          correct: question.answer.toLowerCase() == 'a',
        },
        {
          id: 'b',
          value: question.option_b,
          correct: question.answer.toLowerCase() == 'b',
        },
        {
          id: 'c',
          value: question.option_c,
          correct: question.answer.toLowerCase() == 'c',
        },
        {
          id: 'd',
          value: question.option_d,
          correct: question.answer.toLowerCase() == 'd',
        },
      ]"
      v-if="preview_modal"
      @closeTriggered="togglePreviewModal"
      @clickFeedbackForm="toggleFeedbackModal"
    ></AssessmentPreviewModal>

    <AssessmentFeedbackModal
      v-if="feedback_modal"
      @closeTriggered="toggleFeedbackModal"
      @showAlertInfo="showAlert($event.msg, $event.type)"
    ></AssessmentFeedbackModal>
    <!-- MODAL COMPONENTS -->

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import QuestionCard from "@/components/classComps/assessment/QuestionCard";
import ResponseDialog from "@/components/globalComps/ResponseDialog";

export default {
  name: "ContentInfo",

  props: {
    questions: Array,
    homework_id: Number,
  },

  components: {
    QuestionCard,
    ResponseDialog,
    AssessmentPreviewModal: () =>
      import(
        /* webpackChunkName: " AssessmentPreviewModal" */
        "@/components/modalComps/assessmentModals/AssessmentPreviewModal"
      ),
    AssessmentFeedbackModal: () =>
      import(
        /* webpackChunkName: " AssessmentFeedbackModal" */
        "@/components/modalComps/assessmentModals/AssessmentFeedbackModal"
      ),
  },

  data() {
    return {
      preview_modal: false,
      feedback_modal: false,
      question: [],
      homework: null,

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  methods: {
    ...mapActions(["getQuestionDetails", "reportQuestionError"]),

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    showAlert(msg, type = "error") {
      this.alert_card_msg = msg;
      this.alert_card_type = type;
      this.toggleResponseDialog();
    },

    togglePreviewModal(question_id) {
      this.question = this.questions[question_id];
      this.preview_modal = !this.preview_modal;
    },

    toggleFeedbackModal() {
      this.feedback_modal = !this.feedback_modal;
    },

    questionDetails(question_id) {
      this.getQuestionDetails(question_id)
        .then((res) => {
          if (res.code === 200) {
            this.question = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    reportQuestion(details) {
      // details.reference_id = this.question.id;
      this.reportQuestionError({ ...details, reference_id: this.question.id })
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.question = res.data;
            this.$parent.showAlert(
              "Your feedback has been submitted.",
              "success"
            );
            this.preview_modal = !this.preview_modal;
          } else {
            this.$parent.showAlert(res.message);
          }

          this.toggleFeedbackModal();
        })
        .catch((err) => {
          console.log(err);
          this.$parent.showAlert(
            "Oop.. an error occured while submitting fedback"
          );
        });
    },

    isSelected(q_id) {
      // check if a question is selected..
      try {
        if (
          localStorage.getItem(`questions_${this.homework_id}`) &&
          localStorage.getItem(`questions_${this.homework_id}`) !== undefined
        ) {
          let selectedQuestions = JSON.parse(
            localStorage.getItem(`questions_${this.homework_id}`)
          ).find((e) => e === q_id);
          return selectedQuestions ? true : false;
        } else return false;
      } catch (err) {
        console.log(err);
      }
    },

    pickQuestion(item) {
      this.$emit("selectedQuestion", item);
    },

    removeQuestion(item) {
      this.$emit("removeQuestion", item);
    },
  },
};
</script>

<style lang="scss">
.content-assesssment-info {
  height: 68vh; //63vh;
  overflow-y: auto;
  margin-bottom: 50px;

  @include breakpoint_max(md) {
    height: 66vh;
  }

  @include breakpoint_max(xs) {
    height: 60vh;
  }
}
</style>
